import raw from 'raw.macro';

export default [
  { title: 'SQL Statements', content: raw('./sql.md') },
  { title: 'Selecting Data', content: raw('./select.md') },
  { title: 'Operators', content: raw('./operators.md') },
];
